// extracted by mini-css-extract-plugin
export default {"wrapper":"Slide_wrapper__4ukoU","text":"Slide_text__ZYk+K","kov":"Slide_kov__dxCnu","img":"Slide_img__EU-5S"};